module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-06@2x.370846ee.jpg";